import moment from 'moment'
import {
    isNumber
} from 'util'
import {
    isEqual,
    intersectionWith
} from 'lodash'
import Vue from 'vue'
let isFoldFlag = false

class utils {
    constructor() {
        this.EventBus = null
    }

    // 是否mac系统
    static isMac() {
        return navigator.platform.includes('Mac')
    }

    setBus() {
        // console.log('setBus', this.EventBus);
        if (!this.EventBus) {
            return this.EventBus = new Vue()
        } else {
            return this.EventBus
        }
    }

    static myBrowser() {
        var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
        var isOpera = userAgent.indexOf('Opera') > -1
        if (isOpera) {
            // 判断是否Opera浏览器
            return 'Opera'
        }
        if (userAgent.indexOf('Firefox') > -1) {
            // 判断是否Firefox浏览器
            return 'FF'
        }
        if (userAgent.indexOf('Chrome') > -1) {
            return 'Chrome'
        }
        if (userAgent.indexOf('Safari') > -1) {
            // 判断是否Safari浏览器
            return 'Safari'
        }
        if (
            userAgent.indexOf('compatible') > -1 &&
            userAgent.indexOf('MSIE') > -1 &&
            !isOpera
        ) {
            // 判断是否IE浏览器
            return 'IE'
        }
    }

    static uuid() {
        var s = []
        var hexDigits = '0123456789abcdef'
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-'

        var uuid = s.join('')
        return uuid
    }

    static transformPercent(valueList, inx, precision) {
        // 判断是否为空
        if (!valueList[inx]) {
            return 0
        }

        // 求和

        // var sum = valueList.reduce(function(acc, val) {
        //   return acc + (isNaN(val) ? 0 : val);
        // }, 0);
        //   判断valueList 数组内为string，转化为number
        var sum = valueList
            .map(item => +item)
            .reduce(function (acc, val) {
                return acc + (isNaN(val) ? 0 : val)
            }, 0)
        if (sum === 0) {
            return 0
        }
        // 10的2次幂是100，用于计算精度。
        var digits = Math.pow(10, precision)
        // 扩大比例100，
        var votesPerQuota = valueList.map(function (val) {
            return ((isNaN(val) ? 0 : val) / sum) * digits * 100
        })
        // 总数，扩大比例意味的总数要扩大
        var targetSeats = digits * 100
        // 再向下取值，组成数组
        var seats = votesPerQuota.map(function (votes) {
            return Math.floor(votes)
        })
        // 再新计算合计，用于判断与总数量是否相同，相同则占比会100%
        var currentSum = seats.reduce(function (acc, val) {
            return acc + val
        }, 0)
        // 余数部分的数组：原先数组减去向下取值的数组，得到余数部分的数组
        var remainder = votesPerQuota.map(function (votes, inx) {
            return votes - seats[inx]
        })
        // 给最大最大的余额加1，凑个占比100%；
        while (currentSum < targetSeats) {
            //  找到下一个最大的余额，给其加1
            var max = Number.NEGATIVE_INFINITY
            var maxId = null
            for (var i = 0, len = remainder.length; i < len; ++i) {
                if (remainder[i] > max) {
                    max = remainder[i]
                    maxId = i
                }
            }
            // 对最大项余额加1
            ++seats[maxId]
            // 已经增加最大余数加1，则下次判断就可以不需要再判断这个余额数。
            remainder[maxId] = 0
            // 总的也要加1，为了判断是否总数是否相同，跳出循环。
            ++currentSum
        }
        // 这时候的seats就会总数占比会100%
        return seats[inx] / digits
    }

    static isEmpty(obj) {
        if (!obj && obj !== 0 && obj !== '') {
            return true
        }
        // 检验数组
        if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
            return true
        }
        // 检验对象
        if (Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length === 0) {
            return true
        }
        return false
    }

    static openNewPageRouter(_this, config) {
        if (sessionStorage.getItem('powersign') === '1') {
            _this.$router.push(config)
        } else {
            const {
                href
            } = _this.$router.resolve(config)
            window.open(href, '_blank')
        }
    }

    static getType(obj) {
        const toString = Object.prototype.toString
        const map = {
            '[object Boolean]': 'boolean',
            '[object Number]': 'number',
            '[object String]': 'string',
            '[object Function]': 'function',
            '[object Array]': 'array',
            '[object Date]': 'date',
            '[object RegExp]': 'regExp',
            '[object Undefined]': 'undefined',
            '[object Null]': 'null',
            '[object Object]': 'object'
        }
        if (obj instanceof Element) {
            return 'element'
        }
        return map[toString.call(obj)]
    }

    static deepClone(data) {
        const type = this.getType(data)
        let obj
        if (type === 'array') {
            obj = []
        } else if (type === 'object') {
            obj = {}
        } else {
            // 不再具有下一层次
            return data
        }
        if (type === 'array') {
            for (let i = 0, len = data.length; i < len; i++) {
                obj.push(this.deepClone(data[i]))
            }
        } else if (type === 'object') {
            for (const key in data) {
                obj[key] = this.deepClone(data[key])
            }
        }
        return obj
    }

    static commonResize(options = {}) {
        const {
            el = 'body', duration = 100
        } = options
        setTimeout(() => {
            this.scrollResize(el)
        }, duration)
    }

    static setTranslate(el) {
        // 设置页面中间区域动画
        const _width = window.innerWidth
        const _elWidth = 1080
        const _sideWidth = 310
        let _abbr = 'translateX(0)'
        if (_width <= _elWidth + _sideWidth) {
            if (_width > _elWidth) {
                if (isFoldFlag) {
                    let offset = Math.floor((_width - _elWidth) / 2)
                    offset = offset < 0 ? 0 : offset
                    _abbr = `translateX(-${offset}px)`
                }
            }

            $(el).css({
                transform: _abbr
            })
            return
        }

        if (isFoldFlag) {
            const offset = Math.floor(_sideWidth / 2)
            _abbr = `translateX(-${offset}px)`
        }
        $(el).css({
            transform: _abbr
        })
    }

    static setFoldFlag(status) {
        isFoldFlag = status
    }

    static contentAnimateInit(el, binding, vnode) {
        // 暂时保留， 需修改
        const _vue = vnode.context
        const isFold = _vue.constractShow
        utils.setFoldFlag(isFold)
        utils.setTranslate(isFold)
    }

    // 获取昨天的开始结束时间
    static getYesterday() {
        const date = []
        date.push(
            moment()
                .subtract('days', 1)
                .format('YYYY-MM-DD')
        )
        date.push(
            moment()
                .subtract('days', 1)
                .format('YYYY-MM-DD')
        )
        return date
    }

    // 获取今天之前某一天的开始结束时间
    static getDaysAgo(n) {
        const date = []
        date.push(
            moment()
                .subtract('days', n)
                .format('YYYY-MM-DD')
        )
        date.push(
            moment()
                .subtract('days', n)
                .format('YYYY-MM-DD')
        )
        return date
    }

    // 获取最近n天的开始结束时间
    static getLastAnyDays(n) {
        const date = []
        date.push(
            moment()
                .subtract('days', n)
                .format('YYYY-MM-DD')
        )
        date.push(
            moment()
                .subtract('days', 1)
                .format('YYYY-MM-DD')
        )
        return date
    }

    // 获取最近七天的开始结束时间
    static getLast7Days() {
        const date = []
        date.push(
            moment()
                .subtract('days', 7)
                .format('YYYY-MM-DD')
        )
        date.push(
            moment()
                .subtract('days', 1)
                .format('YYYY-MM-DD')
        )
        return date
    }

    // 获取最近N天的连续开始结束时间
    static getContinueAnyDays(n) {
        const date = []
        for (let i = n; n > 0; n--) {
            date.push(
                moment()
                    .subtract('days', n)
                    .format('YYYY-MM-DD')
            )
        }
        return date
    }

    // 获取最近30天的开始结束时间
    static getLast30Days() {
        const date = []
        date.push(
            moment()
                .subtract('days', 30)
                .format('YYYY-MM-DD')
        )
        date.push(
            moment()
                .subtract('days', 1)
                .format('YYYY-MM-DD')
        )
        return date
    }

    // 获取最近365天的开始结束时间
    static getLast365Days() {
        const date = []
        date.push(
            moment()
                .subtract('days', 365)
                .format('YYYY-MM-DD')
        )
        date.push(
            moment()
                .subtract('days', 1)
                .format('YYYY-MM-DD')
        )
        return date
    }

    // 获取上一周的开始结束时间
    static getLastWeekDays() {
        const date = []
        const weekOfday = parseInt(moment().format('d')) // 计算今天是这周第几天  周日为一周中的第一天
        const start = moment()
            .subtract(weekOfday + 6, 'days')
            .format('YYYY-MM-DD') // 周一日期
        const end = moment()
            .subtract(weekOfday, 'days')
            .format('YYYY-MM-DD') // 周日日期

        // let start = moment().subtract(weekOfday + 7, 'days').format('YYYY-MM-DD') // 周日日期
        // let end = moment().subtract(weekOfday + 1, 'days').format('YYYY-MM-DD') // 周六日期
        date.push(start)
        date.push(end)
        return date
    }

    // 获取前n周的开始结束时间
    static getLastAnyWeekDays(i) {
        const date = []
        const weekOfDay = parseInt(moment().format('E')) // 计算今天是这周第几天
        const start = moment()
            .subtract(weekOfDay + 7 * i - 1, 'days')
            .format('YYYY-MM-DD') // 周一日期
        const end = moment()
            .subtract(weekOfDay + 7 * (i - 1), 'days')
            .format('YYYY-MM-DD') // 周日日期
        date.push(start)
        date.push(end)
        return date
    }

    // 获取上一个月的开始结束时间
    static getLastMonthDays() {
        const date = []
        const start =
            moment()
                .subtract('month', 1)
                .format('YYYY-MM') + '-01'
        const end = moment(start)
            .subtract('month', -1)
            .add('days', -1)
            .format('YYYY-MM-DD')
        date.push(start)
        date.push(end)
        return date
    }

    // 获取当前周的开始结束时间
    static getCurrWeekDays() {
        const date = []
        const weekOfday = parseInt(moment().format('d')) // 计算今天是这周第几天 周日为一周中的第一天
        const start = moment()
            .subtract(weekOfday - 1, 'days')
            .format('YYYY-MM-DD') // 周一日期
        const end = moment()
            .add(7 - weekOfday, 'days')
            .format('YYYY-MM-DD') // 周日日期
        date.push(start)
        date.push(end)
        return date
    }

    // 获取当前月的开始结束时间
    static getCurrMonthDays() {
        const date = []
        const start =
            moment()
                .add('month', 0)
                .format('YYYY-MM') + '-01'
        const end = moment(start)
            .add('month', 1)
            .add('days', -1)
            .format('YYYY-MM-DD')
        date.push(start)
        date.push(end)
        return date
    }

    // 获取前n个月的开始结束时间
    static getLastAnyMonthDays(n) {
        const date = []
        const start =
            moment()
                .subtract('month', n)
                .format('YYYY-MM') + '-01'
        const end = moment(start)
            .subtract('month', -1)
            .add('days', -1)
            .format('YYYY-MM-DD')
        date.push(start)
        date.push(end)
        return date
    }

    static sortByObjKey(list, key, desc = true) {
        // 默认降序
        function sortNumber(a, b) {
            if (desc) {
                return b[key] - a[key]
            } else {
                return a[key] - b[key]
            }
        }
        return list.sort(sortNumber)
    }

    static thousandsFormat(num, precision = 0) {
        if (typeof num === 'string' && !num.trim()) {
            return ''
        }
        if (num == undefined) {
            return
        }

        num = isNaN(Number(num)) ? num : parseFloat(num)
        // num = isNaN(parseFloat(num)) ? num : parseFloat(num);
        num = (num.toFixed ? num.toFixed(precision) : num) + ''
        if (!num.includes('.')) num += '.'
        return num
            .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
                return $1 + ','
            })
            .replace(/\.$/, '')
    }

    // 100,000+等的规则
    static formatLongNum(num, type) {
        // 10w以下的数展示全数，>100000 && <110000 展示 10w+,>110000&& <120000 展示 11w+,
        if (isNumber(num)) {
            return this.thousandsFormat(num, 0)
        }
        const total = Math.floor(num / 100000)
        return this.thousandsFormat(total * 100000, 0) + '+'
    }


    // 兼容单选组件，创建label,value. ['a'] => [{label: 'a', value: 'a'}]
    static createSingleObj(arr, needUnlimited = true) {
        const _arr = arr.map(item => {
            return {
                label: item,
                value: item
            }
        })

        if (needUnlimited) {
            _arr.unshift({
                label: '不限',
                value: '不限'
            })
        }

        return _arr
    }

    // 生产测试单选数据
    static tempSingleArr(length, word) {
        return Array.from({
            length
        }).map((item, index) => {
            return `${word}${index + 1}`
        })
    }

    // 判断两个数组是否相同

    static scalarArrayEquals(array1, array2) {
        return (
            array1.length === array2.length &&
            JSON.stringify(array1) === JSON.stringify(array2)
        )
    }

    static isEqual(origin, target) {
        if (typeof target !== 'object') {
            // target不是对象/数组
            return origin === target // 直接返回全等的比较结果
        }

        if (typeof origin !== 'object') {
            // origin不是对象/数组
            return false // 直接返回false
        }
        for (const key of Object.keys(target)) {
            // 遍历target的所有自身属性的key
            if (!this.isEqual(origin[key], target[key])) {
                // 递归比较key对应的value，
                // value不等，则两对象不等，结束循环，退出函数，返回false
                return false
            }
        }
        // 遍历结束，所有value都深度比较相等，则两对象相等
        return true
    }

    // 输入文本去除特殊字符
    static replaceSpecialCharts(val) {
        return val
            .replace(
                /[`～*~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,
                ''
            )
            .replace(/\s/g, '')
    }

    static getDiffNum(num, defaultInfo, nowInfo) {
        for (const key in defaultInfo) {
            if (Array.isArray(defaultInfo[key])) {
                const intersections = intersectionWith(
                    defaultInfo[key],
                    nowInfo[key],
                    isEqual
                )
                if (intersections.length !== defaultInfo[key].length) {
                    num++
                }
            } else {
                if (!isEqual(defaultInfo[key], nowInfo[key])) {
                    num++
                }
            }
        }
        return num
    }

    static formatDateTime(date, fmt = 'yyyy-MM-dd HH:mm:ss') {
        if (typeof date === 'number') date = new Date(date)
        const o = {
            'M+': date.getMonth() + 1, // 月份
            'd+': date.getDate(), // 日
            'H+': date.getHours(), // 小时
            'm+': date.getMinutes(), // 分
            's+': date.getSeconds(), // 秒
            S: date.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
        for (const k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
        }
        return fmt
    }

    // 数值转千字符
    static toThousands(num) {
        var result = []; var counter = 0
        if (num < 1000) {
            return num
        }
        num = (num || 0).toString().split('')
        for (var i = num.length - 1; i >= 0; i--) {
            counter++
            result.unshift(num[i])
            if (!(counter % 3) && i !== 0) { result.unshift(',') }
        }
        return result.join('')
    }
}

export default utils
